import moment from 'moment-timezone';

export const defaultFormat = 'DD/MM/YY h:mm:ss a';

export function timeFormatter(utcTime, hideTimeZone) {
    if (utcTime) {
        return moment.utc(utcTime).tz('Europe/Brussels').format('MMMM D YYYY, hh:mm:ss a') + (hideTimeZone === true ? "" : " (UTC+2)");
    }
}

export function formatDuration(seconds) {
    const totalMinutes = Math.round(seconds / 60);
    const days = Math.floor(totalMinutes / (24 * 60));
    const hours = Math.floor((totalMinutes % (24 * 60)) / 60);
    const minutes = totalMinutes % 60;
    
    const parts = [];
    if (days > 0) parts.push(`${days}d`);
    if (hours > 0) parts.push(`${hours}h`);
    if (minutes > 0) parts.push(`${minutes}m`);
    
    return parts.length > 0 ? parts.join(' ') : '0m';
}

// Safe math utility functions
export function safeNumber(value, defaultValue = 0) {
    if (value == null || isNaN(value) || !isFinite(value)) {
        return defaultValue;
    }
    return Number(value);
}

export function safeMath(value, operation = 'round', defaultValue = 0) {
    const safeValue = safeNumber(value, defaultValue);
    
    switch (operation) {
        case 'round':
            return Math.round(safeValue);
        case 'floor':
            return Math.floor(safeValue);
        case 'ceil':
            return Math.ceil(safeValue);
        default:
            return safeValue;
    }
}